import { AlertService } from 'src/app/services/alert/alert.service';
import { ExceptionsService } from 'src/app/services/exceptions/exceptions.service';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/services/dataStore/data.service';
import { DatePipe, formatDate } from '@angular/common';
import { DateFilterService } from 'src/app/services/date/date-filter.service';
import { Calendar } from 'primeng/calendar';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { SharedService } from 'src/app/services/shared.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
  POLineData = [];
  selectedPOLines = [];
  type: string;
  component: string;
  uploadBool: boolean = false;
  GRNData = [];
  po_num: string;
  approveBool: boolean = false;
  entityList = [];
  approverList: any;
  rejectionComments: string;
  isQuantityChanged: boolean;
  linesTotal: number = 0;
  inv_total: number;
  select_all_bool: boolean;
  approversSendData: any;
  lineTable = [
    { name: 'Description', data: [] },
    { name: 'PO Quantity', data: [] },
    { name: 'Balance Qty', data: [] }
  ];
  orderHistoryData: any;
  masterData: any;
  orderData: any;
  textlngth: any;
  updateSOObj: any;
  line_num: number;
  v_a_id: any;
  so_id: any;
  minDate: Date;
  maxiDate: Date;
  rangeDates: Date[];
  @ViewChild('datePicker') datePicker: Calendar;
  manPowerData = [];
  manPowerMetadata = [];
  grnLineCount: any
  timeSheet: any[];
  replicaSheetData = [];
  manpowerTableHeaders: { header: string; field: string; }[];
  number_of_days: number;
  disabledDates: Date[] = [];
  startDate: Date;
  endDate: Date;
  isEditGRN: boolean = false;
  createdDates = [];
  decimal_count = 2;
  manPowerTable = [
    { header: 'S.No', field: '' },
    { header: 'Description', field: 'Name' },
    { header: 'PO Qty', field: 'PurchQty' },
    { header: 'GRN - Qty', field: 'GRNQty' },
    { header: 'PO Balance Qty', field: 'RemainPurchPhysical' },
    { header: 'Shift', field: 'shiftName' }
  ];
  disabledSaveMetadata: boolean = true;

  resizing: boolean = false;
  startX: number;
  startY: number;
  startWidth: number;
  startHeight: number;
  isResizingEnabled = false;
  dragRootElement = '.cdk-overlay-pane';
  prepayArr = [];
  prepayTotal: number = 0;
  select_all_bool_prepay: boolean;
  grnList = [];
  selectedGRNList = [];
  selectedGRNLines = [];
  filterGRNList: any;
  selected_GRN_total: any;
  PO_GRN_Number_line = [];
  invoice_number: string;
  invoice_lines: any;
  line_table_headers: any;
  is_document_view: boolean;
  is_inv_line_view = true;
  is_grn_list_expanded: boolean;

  constructor(
    public dialogRef: MatDialogRef<PopupComponent>,
    private ES: ExceptionsService,
    private alert: AlertService,
    private spin: NgxSpinnerService,
    private ds: DataService,
    private mat_dlg: MatDialog,
    private datePipe: DatePipe,
    private dateFilterService: DateFilterService,
    private sharedService: SharedService,
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.type = this.data.type;
    this.rejectionComments = this.data.rejectTxt
    this.po_num = this.data?.po_num
    let grn = this.data?.grnLine;
    this.POLineData = this.data?.resp?.podata;
    this.inv_total = this.data?.resp?.sub_total;
    this.isEditGRN = this.ds?.isEditGRN;
    this.prepayArr = this.data?.resp?.prepayData;
    if (this.prepayArr?.length > 0) {
      this.prepayArr.forEach(val => {
        val.amount = val.InvoiceAmount;
      })
    }
    this.decimal_count = this.ds?.configData?.miscellaneous?.No_of_Decimals;
    if (!this.decimal_count) {
      this.decimal_count = 2;
    }
    if (this.ds?.configData?.client_name == 'Cenomi') {
      if (this.router.url.includes('Inv_vs_GRN_details')) {
        this.decimal_count = 5;
      }
    }

    if (grn) {
      grn?.forEach(el => {
        let obj = { LineNumber: el.POLineNumber, grnpackagingid: el.PackingSlip };
        this.GRNData.push(obj);
      })
    }
    this.initialize();
  }

  initialize() {
    if (this.type == 'flip' || this.type == 'flip returns') {
      this.component = 'normal';
      this.flipPOFun();
    } else if (this.type == 'flip line') {
      this.component = 'mapping';
      this.flipPOFun();
    } else if (this.type == 'editApprover') {
      this.approveBool = true;
      this.flipApproverlist();
    } else if (this.type == 'prepay') {
      this.prepayArr.forEach(val => {
        val.isSelected = false;
      })
    } else if (this.type == 'manpower') {
      this.dateRange();
      this.manPowerData = this.ds.added_manpower_data;
      if (this.isEditGRN) {
        this.getTimeSheetData();
      }
      if (!this.manPowerData) {
        this.manpowerCreateFunction();
      } else {
        const s_Date = this.datePipe.transform(this.ds.manpower_saved_date_range[0], 'yyyy-MM-dd');
        const e_Date = this.datePipe.transform(this.ds.manpower_saved_date_range[1], 'yyyy-MM-dd');
        this.manPowerData = this.addDatesToRecords(this.manPowerData, s_Date, e_Date);
      }

    } else if (this.type == 'manpower_metadata') {
      // this.manPowerMetadata = JSON.parse(JSON.stringify(this.data?.resp?.manpower_metadata));
      this.manPowerMetadata = this.ds.GRN_PO_Data.map(ele => {
        const matchingItem = this.ds?.grn_manpower_metadata?.headerFields?.find(item => item.itemCode == ele.LineNumber);
        return {
          description: ele.Name,
          itemCode: ele.LineNumber,
          durationMonth: matchingItem?.durationMonth || '',
          isTimesheets: matchingItem ? true : false,
          shifts: matchingItem?.shifts || ''
        };
      });
      // Create table headers
      this.manpowerTableHeaders = [
        { header: 'Description', field: 'description' },
        { header: 'Is Timesheets', field: 'isTimesheets' },
        { header: 'Duration in months', field: 'duration' },
        { header: 'Number of Shifts', field: 'shifts' }
      ];
    } else if (this.type == 'selectGRN') {
      this.grnList = this.data?.resp?.grnData;
      this.filterGRNList = this.grnList;
      this.invoice_number = this.data?.resp?.invoiceNumber;
      this.invoice_lines = this.data?.resp?.invoice_lines;
      this.line_table_headers = this.data?.resp?.tableHeaders || ['GRNDescription', 'GRNQuantity', 'GRNUnitPrice', 'discountedUnitPrice', 'AmountExcTax', 'Discount', 'DiscPercent'];
      this.isResizingEnabled = true;
    }
    if (this.data.comp == 'upload') {
      this.uploadBool = true;
    }
    // this.POLineData = this.data?.resp?.podata;
    this.inv_total = this.data?.resp?.sub_total;
  }
  flipPOFun() {
    this.POLineData.forEach(val => {
      val.isSelected = false;
      val.Quantity = val.PurchQty;
      val.AmountExcTax = this.calculateAmount(val);
    })
  }
  onSubmit(value) {
    this.spin.show();
    this.ES.flip_po(this.selectedPOLines).subscribe((data: any) => {
      if (data?.result) {
        if (data.Flippo_Approval) {
          this.flipApproverlist();
          this.success("PO flip is successful")
          this.approveBool = true;
          this.spin.hide();
        } else {
          this.ES.popupmsg.next(this.component);
          this.success("PO flip is successful")
          this.dialogRef.close();
        }
      } else {
        this.error(data?.error)
        this.spin.hide();
      }

    }, err => {
      this.error("Server error");
      this.spin.hide();
    })
  }
  calculateAmount(data) {
    let lineTotal;
    if (data?.DiscPercent && data?.DiscPercent != '0') {
      let total: any = this.ES.roundDecimalOperands(data?.Quantity, data?.UnitPrice * (1 - data?.DiscPercent / 100), this.decimal_count)
      lineTotal = total;
    } else if (data?.DiscAmount && data?.DiscAmount != '0') {
      let total: any = this.ES.roundDecimalOperands(data?.Quantity, data?.UnitPrice - data?.DiscAmount, this.decimal_count);
      lineTotal = total;
    } else {
      let total: any = this.ES.roundDecimalOperands(data?.Quantity, data?.UnitPrice, this.decimal_count)
      lineTotal = total;
    }
    return lineTotal;
  }
  onSelect(bool, data, field) {
    let id = `${data[field]}-grnQty`;
    data.Quantity = (<HTMLInputElement>document.getElementById(id)).value;
    if (bool) {
      let boolean = this.selectedPOLines?.findIndex(el => el[field] == data[field]);
      if (boolean) {
        this.selectedPOLines.push(data);
        let lineTotal = this.calculateAmount(data);
        this.linesTotal = Number(this.linesTotal) + Number(this.decimalRoundOff(lineTotal));
      }
    } else {
      const ind = this.selectedPOLines?.findIndex(el => el[field] == data[field]);
      if (ind != -1) {
        this.selectedPOLines.splice(ind, 1)
        let lineTotal = this.calculateAmount(data);
        this.linesTotal = Number(this.linesTotal) - Number(this.decimalRoundOff(lineTotal));
        // this.linesTotal = Number(this.linesTotal) - Number((data?.Quantity * data?.UnitPrice).toFixed(2))
      }
    }
    if (this.selectedPOLines.length == this.POLineData.length) {
      this.select_all_bool = true;
    } else {
      this.select_all_bool = false;
    }
  }
  onSelectAll(bool, field) {
    if (bool) {
      this.linesTotal = 0;
      this.POLineData.forEach(val => {
        val.isSelected = true;
        let id = `${val[field]}-grnQty`;
        val.Quantity = (<HTMLInputElement>document.getElementById(id)).value;
        let lineTotal = this.calculateAmount(val);
        // let lineTotal = val?.DiscAmount ? (val?.Quantity * (val?.UnitPrice - val?.DiscAmount)) : (val?.Quantity * val?.UnitPrice); 
        this.linesTotal = Number(this.linesTotal) + Number(this.decimalRoundOff(lineTotal));
        // this.linesTotal = Number(this.linesTotal) + Number((val?.Quantity * val?.UnitPrice).toFixed(2))
      })
      const allData = [...this.POLineData]
      this.selectedPOLines = allData;
      this.select_all_bool = true;
    } else {
      this.select_all_bool = false;
      this.selectedPOLines = [];
      this.linesTotal = 0;
      this.POLineData.forEach(val => {
        val.isSelected = false;
      })
    }
  }
  changeQty(qty, lineid, field) {
    let el_flied = 'Quantity';
    this.isQuantityChanged = true;
    this.linesTotal = 0;
    if (this.type == 'flip returns') {
      el_flied = 'rtn_qty'
    }
    this.selectedPOLines.forEach(el => {
      if (el[field] == lineid) {
        el[el_flied] = qty;
      }
      let lineTotal = this.calculateAmount(el);
      this.linesTotal = Number(this.linesTotal) + Number(this.decimalRoundOff(lineTotal));
      // this.linesTotal = Number(this.linesTotal) + Number((el?.Quantity * el?.UnitPrice).toFixed(2))
    });
    // this.linesTotal = 0;
    this.POLineData.forEach(el => {
      if (el.LineNumber == lineid) {
        el.Quantity = qty;
      }
      // this.linesTotal = Number(this.linesTotal) + Number((el.PurchQty * el.UnitPrice).toFixed(2))

    })
  }
  onSubmitRequest(val) {
    this.dialogRef.close(this.rejectionComments);
  }

  validateFlip() {
    this.spin.show();
    if (this.type != 'flip returns') {
      let obj = {
        Podata: this.selectedPOLines,
        GRNdata: this.GRNData
      }
      this.ES.validateFlipPO(obj, this.po_num).subscribe((data: string) => {
        if (data == 'success') {
          this.ES.popupmsg.next(this.component);
          this.success("PO flip is successful")
          this.dialogRef.close(this.selectedPOLines);
        } else {
          this.error(data)
        }
        this.spin.hide();
      }, err => {
        this.error("Server error");
        this.spin.hide();
      });
    } else {
      let APIdata = [];
      this.selectedPOLines.forEach(el => {
        APIdata.push({
          "description": el.Description,
          "rtn_qty": el.rtn_qty || el.Quantity,
          "item_code": el.itemCode,
          "po_line_number": el.itemCode,
          "inv_qty": el.Quantity
        })
      })
      this.ES.validateReturns(APIdata).subscribe((data: any) => {
        if (data.result == 'Success') {
          this.success("Successful")
          this.dialogRef.close(APIdata);
        } else {
          this.error(data.result)
        }
        this.spin.hide();
      }, err => {
        this.error("Server error");
        this.spin.hide();
      });
    }

  }

  flipApproverlist() {
    this.ES.getFlipApprovers().subscribe((data: any) => {
      let resultData = data?.result;
      this.approverList = data?.result
      let array = [];
      let list = [];
      let count = 0;
      for (const item in resultData) {
        count = count + 1;
        // list = resultData[item].sort((a, b) => a.priority - b.priority);
        // console.log(item)
        // this.approverList[`${item}`] = list;
        // console.log(item)
        array.push(resultData[item][0]);
      }
      this.approversSendData = array;
    })
  }
  onSelectApprovers(val, i) {

  }

  setApprover() {
    this.ES.setFlipApproval(this.approversSendData).subscribe((data) => {
      this.success("Successfully sent for Approvals")
      this.dialogRef.close('success');
    }, err => {
      this.error("Server error");
    })
  }

  updateMapping() {
    this.ES.updateSOmap(this.so_id, this.v_a_id, this.updateSOObj).subscribe((data) => {
      // this.alert.addObject.detail = "SO Line is mapped successfully";
      // this.message.add(this.alert.addObject);
      this.dialogRef.close('Mapped');
    })
  }
  success(msg) {
    this.alert.success_alert(msg);
  }
  error(msg) {
    this.alert.error_alert(msg);
  }

  // Function to generate all dates between start and end date
  generateDisabledDates(start: Date, end: Date): void {
    let currentDate = new Date(start);

    while (currentDate <= end) {
      this.disabledDates.push(new Date(currentDate));
      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }
  dateRange() {
    this.dateFilterService.dateRange();
    this.minDate = this.dateFilterService.minDate;
    this.maxiDate = this.dateFilterService.maxDate;

    // for disabling the dates
    const datesFilled = this.ds.grn_manpower_metadata?.datesFilled;
    if (datesFilled.length > 0) {
      let date = datesFilled[0]?.startdate;
      let day = date.split('-')[2];
      let month = date.split('-')[1];
      let year = date.split('-')[0];
      let e_date = datesFilled[0].enddate;
      let e_day = e_date.split('-')[2];
      let e_month = e_date.split('-')[1];
      let e_year = e_date.split('-')[0];
      this.startDate = new Date(year, month - 1, day);
      this.endDate = new Date(e_year, e_month - 1, e_day);
      this.generateDisabledDates(this.startDate, this.endDate);
    }
  }

  filterByDate(date_input: any) {
    let noOfDays = 0;
    if (date_input && date_input.length != 2) {
      date_input = new Date(date_input);
      const selectedMonth = date_input.getMonth();
      const selectedYear = date_input.getFullYear();

      const prevMonth = new Date(selectedYear, selectedMonth - 1, 1);
      const currMonth = new Date(selectedYear, selectedMonth, 1);

      const daysInPrevMonth = new Date(prevMonth.getFullYear(), prevMonth.getMonth() + 1, 0).getDate();
      const daysInCurrMonth = new Date(currMonth.getFullYear(), currMonth.getMonth() + 1, 0).getDate();


      // const daysInRangePrevMonth = daysInPrevMonth - startDay + 1;
      // const daysInRangeCurrMonth = endDay;
      date_input = [new Date(selectedYear, selectedMonth - 1, daysInPrevMonth - 6), new Date(selectedYear, selectedMonth, daysInCurrMonth - 7)];
      noOfDays = date_input[1].getDate() + 6;
    }
    if (date_input != '' && date_input?.length > 0) {
      if (this.isEditGRN) {
        this.rangeDates = date_input
      }
      const frmDate = this.datePipe.transform(date_input[0], 'MMM d, y');
      const toDate = this.datePipe.transform(date_input[1], 'MMM d, y');
      const s_Date = this.datePipe.transform(date_input[0], 'yyyy-MM-dd');
      const e_Date = this.datePipe.transform(date_input[1], 'yyyy-MM-dd');
      let selectedMonth: any = s_Date.split("-")[1]
      let today = new Date();
      let c_month: any = today.getMonth()
      let year: any = s_Date.split("-")[0];
      if (Number(selectedMonth) != c_month + 1) {

        this.maxiDate = new Date(Number(year), Number(selectedMonth), 0)
        setTimeout(() => {
          const input = document.querySelector('.p-inputtext') as HTMLElement;
          if (input && !e_Date) {
            input.focus();  // Re-focus the input element to keep the calendar open
          }
        }, 0);
      }
      this.number_of_days = noOfDays;
      this.ds.number_of_days = this.number_of_days;
      if (frmDate && toDate) {
        this.ds.manpower_saved_date_range = [date_input[0], date_input[1]];
        // this.getTimeSheetData(s_Date,e_Date);
        if (!this.isEditGRN && this.datePicker.overlayVisible) {
          this.datePicker.hideOverlay();

        }
        let old_data = [];
        this.ES.getManpowerPrefill(this.sharedService.po_num, this.sharedService.po_doc_id, s_Date, e_Date).subscribe((data: any) => {
          old_data = data?.data?.timesheets;
          if (old_data.length > 0) {
            let item_codes = [];
            old_data.filter(el => {
              if (!item_codes.includes(el.itemCode)) {
                item_codes.push(el.itemCode)
              }
            })
            let va_bool: boolean;
            let lineArr = [];
            this.manPowerData.filter(id => {
              if (!lineArr.includes(id.LineNumber.Value)) {
                lineArr.push(Number(id.LineNumber.Value))
              }
            });
            va_bool = lineArr.every(e => item_codes.includes(e))
            if (old_data.length > 0 && !this.isEditGRN && va_bool) {
              const matD: MatDialogRef<ConfirmationComponent> = this.confirmFun("Overlapping dates are there. Please close this window and try again with another date range.", "ok", "Information", 'info')

              matD.afterClosed().subscribe((bool) => {
                this.dialogRef.close();
              })
            }
            old_data.forEach(el => {
              el.quantity.forEach(item => {
                item.itemCode = el.itemCode
                item.LineNumber = el.itemCode
                // if(el.shift == 'Shift 1'){
                //   item.tagName = 'timeSheet0'
                // }
                // if(el.shift == 'Shift 2'){
                //   item.tagName = 'timeSheet1'
                // }
                // if(el.shift == 'Shift 3'){
                //   item.tagName = 'timeSheet2'
                // }
                // if(el.shift == 'Shift 4'){
                //   item.tagName = 'timeSheet3'
                // }
              })
            })
          }

          let month = frmDate?.split(',')[0]?.split(' ')[0];
          let date: any = frmDate?.split(',')[0]?.split(' ')[1];
          let date1: any = toDate?.split(',')[0]?.split(' ')[1];
          let sampleData = JSON.parse(JSON.stringify(this.manPowerData))

          if (old_data.length > 0) {
            sampleData.forEach(el => {
              old_data.forEach(old => {
                if (el?.LineNumber?.Value == old?.itemCode) {
                  old.quantity.forEach(qty => {
                    let tag = qty.date;
                    el[tag] = { Value: qty.quantity }
                  })
                }
              })
            })
          }
          this.timeSheet = [];
          if (date && date1) {
            this.manPowerData = this.addDatesToRecords(sampleData, s_Date, e_Date);
          }
        })

      }

    }
  }
  resetTime(date: any): Date {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      console.error("Invalid date:", date);
      throw new TypeError("Invalid date object passed to resetTime.");
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  generateDateRange(startDate: string, endDate: string): Date[] {
    const dates: Date[] = [];

    // Convert date strings to Date objects
    const start = this.resetTime(new Date(startDate + 'T00:00:00'));
    const end = this.resetTime(new Date(endDate + 'T00:00:00'));

    let currentDate = start;

    while (currentDate <= end) {
      dates.push(new Date(currentDate)); // Push a copy of the current date
      currentDate.setDate(currentDate.getDate() + 1); // Increment day
    }
    return dates;
  }

  // Main function to update records with date fields
  addDatesToRecords(records: any[], startDate, endDate): any[] {
    const dateRange = this.generateDateRange(startDate, endDate);

    // Clear previous date fields from records
    records.forEach(record => {
      Object.keys(record).forEach(key => {
        if (this.manPowerTable.some(rec => rec.header === key)) {
          delete record[key];
        }
      });
    });

    // Clear previous date headers from manPowerTable
    this.manPowerTable = this.manPowerTable.filter(rec =>
      !rec.header.match(/^\d{4}-\d{2}-\d{2}$/)
    );

    // Add new date fields and headers
    records.forEach((record, recordIndex) => {
      dateRange.forEach((date, dateIndex) => {
        const formattedDate = formatDate(date, 'yyyy-MM-dd', 'en-US');
        if (!this.manPowerTable.some(rec => rec.header === formattedDate)) {
          this.manPowerTable.push({ header: formattedDate, field: formattedDate });
        }
        record[`${formattedDate}`] = {
          Value: record[`${formattedDate}`]?.Value || '',
          id: `date_${recordIndex}_${dateIndex}`
        };
      });
    });
    return records;
  }

  clearDates() {
    this.filterByDate('');
    this.dateRange();
  }

  // addNewShift(str, index) {
  //   this.manPowerData.forEach(el => {
  //     el.linedata.splice(index + 1, 0, JSON.parse(JSON.stringify(el.linedata[index])))
  //   })
  //   this.manPowerData.forEach(el => {
  //     el.linedata.forEach((v, i) => {
  //       if (index + 1 == i && el.TagName != 'Description' && el.TagName != "PO Qty") {
  //         v.tagName_u = `shift${index + 1}-${el.TagName}`
  //       }
  //     })
  //   })
  // }

  // removeShift(str, index) {
  //   const matD: MatDialogRef<ConfirmationComponent> = this.mat_dlg.open(ConfirmationComponent, {
  //     width: '400px',
  //     height: '300px',
  //     hasBackdrop: false,
  //     data: { body: "Are you sure, you want to delete?", type: "confirmation", heading: "Confirmation", icon: 'assets/Serina Assets/new_theme/Group 1336.svg' }
  //   })
  //   matD.afterClosed().subscribe((bool: Boolean) => {
  //     if (bool) {
  //       this.manPowerData.forEach((el) => {
  //         el.linedata.splice(index, 1)
  //       })
  //     }
  //   })
  // }

  getTimeSheetData() {
    this.ES.getManPowerData().subscribe((data: any) => {
      if (data?.data) {
        const fDate = new Date(data?.data?.startdate);
        const eDate = new Date(data?.data?.enddate)
        let dates = [fDate, eDate]
        this.filterByDate(dates)
      }
      if (data?.data?.timesheets?.length > 0) {
        data?.data?.timesheets[0].quantity.forEach(e => {
          if (!this.createdDates.includes(e.date)) {
            this.createdDates.push(e.date);
          }
        })
      }
    })
  }
  updateManpowerMetadata(index: number, field: string, value: any, row: any) {
    if (!value) {
      this.disabledSaveMetadata = false;
      return;
    }
    this.manPowerMetadata[index][field] = value;
    let existingRecord = this.ds.grn_manpower_metadata.headerFields.find(el => el.itemCode == row);
    if (existingRecord) {
      existingRecord[field] = value;
    } else {
      this.ds.grn_manpower_metadata.headerFields.push({
        itemCode: row,
        [field]: value
      });
    }
    this.ds.grn_manpower_metadata.headerFields.forEach(el => {
      if (Object.keys(el).length <= 3) {
        this.disabledSaveMetadata = true;
      } else {
        this.disabledSaveMetadata = false;
      }
    })
    // this.ds.grn_manpower_metadata.headerFields[index][field] = value;
  }
  saveManpowerMetadata() {
    this.dialogRef.close(this.manPowerMetadata);
  }


  onSubmitManpower() {
    let startDate = this.datePipe.transform(this.ds.manpower_saved_date_range[0], 'yyyy-MM-dd');
    let endDate = this.datePipe.transform(this.ds.manpower_saved_date_range[1], 'yyyy-MM-dd');
    let response = {
      dates: { startdate: startDate, enddate: endDate },
      data: this.manPowerData
    }
    this.dialogRef.close(response);
    this.ds.added_manpower_data = this.manPowerData;
    this.ds.manpowerResponse = response;
  }
  closeDialog(bool, bool1) {
    if (bool && bool1) {
      const matD: MatDialogRef<ConfirmationComponent> = this.confirmFun("You have unsaved timesheet data. Are you sure you want to cancel? Please click 'Save' to proceed.", "confirmation", "Confirmation", 'delete')
      matD.afterClosed().subscribe((bool: Boolean) => {
        if (bool) {
          this.dialogRef.close();
        }
      })
    } else {
      this.dialogRef.close();
    }
  }

  manpowerCreateFunction() {
    this.replicaSheetData = JSON.parse(JSON.stringify(this.data?.resp?.grnData_po));
    // Step 1: Filter out the entries where "isTimesheet" value is false
    const isTimesheetsItems = this.replicaSheetData.filter((item: any) => item['isTimesheets']?.Value == true);
    let tableData = [];
    isTimesheetsItems.forEach((s, index) => {
      const s_count: number = s['shifts']?.Value;
      for (let i = 0; i < s_count; i++) {
        const duplicatedS = { ...s };

        // Iterate over each property of the duplicated object
        for (const tag in duplicatedS) {
          if (typeof duplicatedS[tag] === 'object' && duplicatedS[tag] !== null) {
            duplicatedS[tag] = { ...duplicatedS[tag], id: `${tag}_${index}_${i}` };
          }
        }

        // Add a unique shift name and ID
        duplicatedS['shiftName'] = { Value: `Shift ${i + 1}`, id: `ShiftName_${index}_${i}` };

        tableData.push(duplicatedS);
      }
    });

    this.manPowerData = tableData;
  }

  onChange(line, value) {
    const numberOfDays = this.ds.number_of_days;
    const lineNumber = line.LineNumber.Value;
    let totalShiftsData = 0;
    let shiftsCount = 0;
    this.manPowerData.forEach(ele => {
      if (ele.LineNumber.Value == lineNumber) {
        for (const tag in ele) {
          if (!['GRNAmountExcTax', 'GRNQty', 'LineNumber', 'Name', 'PurchId', 'PO Balance Qty', 'percentage_po', 'RemainPurchPhysical', 'PurchQty', 'RemainInventPhysical', 'RemainPurchPhysical', 'UnitPrice', 'durationMonth', 'isTimesheets', 'monthlyQuantity', 'shiftName', 'shifts'].includes(tag)) {
            if (ele[tag].Value !== '' && ele[tag].Value != null && !isNaN(Number(ele[tag].Value))) {
              totalShiftsData = totalShiftsData + Number(ele[tag].Value)
            }
          }
        }
        if (ele.shifts.Value) {
          shiftsCount = Number(ele.shifts.Value);
        }
      }
    });
    if (shiftsCount > 0) {
      const grnQty = totalShiftsData / (Number(numberOfDays));
      this.manPowerData.forEach(ele => {
        if (ele.LineNumber.Value == lineNumber) {
          ele.GRNQty.Value = grnQty.toFixed(this.decimal_count);
        }
      });
    }
  }

  confirmFun(body, type, head, confirm_type) {
    return this.mat_dlg.open(ConfirmationComponent, {
      panelClass: 'blur-dialog-panel',
      width: '253px',
      height: '238px',
      hasBackdrop: false,
      data: { body: body, type: type, heading: head, confirm_type: confirm_type }
    })
  }
  toggleResize() {
    this.isResizingEnabled = !this.isResizingEnabled;
  }
  decimalRoundOff(num: any) {
    return Number(num).toLocaleString(undefined,
      {
        minimumFractionDigits: this.decimal_count,
        maximumFractionDigits: this.decimal_count,
        useGrouping: false
      });
  }
  preciseMultiply(value) {
    let factor = Math.pow(10, this.decimal_count + 1);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  }

  onPrePaySubmit(val) {
    let arr = [];
    this.prepayArr.forEach(el => {
      if (el.isSelected) {
        arr.push(
          {
            "po_number": el.PurchaseOrder,
            "invoice_id": el.InvoiceId,
            "prepay_application_remaining": el.PrepayApplicationRemaining,
            "invoiceamt": el.InvoiceAmount,
            "amount": el.amount
          },
        )
      }
    });
    this.ES.saveApplyPrePayment(arr).subscribe((data: any) => {
      if (data?.result == 'success') {
        this.alert.success_alert(data?.msg);
        this.dialogRef.close(this.prepayTotal);
      } else {
        this.error(data?.msg);
      }
    }, err => {
      this.error("Server error");
    });
  }
  onSelectAllPrepay(bool) {
    if (bool) {
      this.prepayTotal = 0;
      this.prepayArr.forEach(val => {
        val.isSelected = true;
        this.prepayTotal = Number(this.prepayTotal) + Number(this.decimalRoundOff(val.amount));
      });
      this.select_all_bool_prepay = true;
    } else {
      this.select_all_bool_prepay = false;
      this.prepayTotal = 0;
      this.prepayArr.forEach(val => {
        val.isSelected = false;
      })
    }
  }
  onSelectPrepay(bool, val) {
    if (bool) {
      val.isSelected = true;
      this.prepayTotal = Number(this.prepayTotal) + Number(this.decimalRoundOff(val.amount));
    } else {
      val.isSelected = false;
      this.prepayTotal = Number(this.prepayTotal) - Number(this.decimalRoundOff(val.amount));
    }
    this.select_all_bool_prepay = this.prepayArr.every(val => val.isSelected);
  }
  changePrepayAmount(value, invoiceId) {
    this.prepayTotal = 0;
    this.prepayArr.forEach(val => {
      if (val.InvoiceId == invoiceId) {
        val.amount = value
      }
      if (val.isSelected) {
        this.prepayTotal = Number(this.prepayTotal) + Number(this.decimalRoundOff(val.amount));
      }
    });
    // this.prepayTotal = Number(this.prepayTotal) + Number(this.decimalRoundOff(value));
  }

  GRNSearch(val) {
    this.grnList = this.filterGRNList;
    if (this.grnList?.length > 0) {
      this.grnList = this.grnList.filter(el => {
        return el.GRNNumber.toLowerCase().includes(val.toLowerCase())
      });
    }
  }

  selectedGRN(event, grn_num) {
    this.spin.show();
    if (grn_num.mapped && event.target.checked) {
      const drf: MatDialogRef<ConfirmationComponent> = this.confirmFun("Are you sure you want to map this GRN again?", 'confirmation', 'Confirmation', 'normal')
      drf.afterClosed().subscribe((bool: Boolean) => {
        if (bool) {
          this.grnFunction(event, grn_num);
        } else {
          this.grnList.forEach(grn => {
            if (grn.GRNNumber == grn_num.GRNNumber) {
              grn.isChecked = false;
            }
          });
          this.spin.hide();
        }
      })
    } else {
      this.grnFunction(event, grn_num);
    }
  }
  grnFunction(event, grn_num) {
    this.spin.hide();
    // delete this.updateInvoiceData;
    let bool: boolean = event.target.checked;
    this.readGRNLines(grn_num.idDocument, bool);
  }
  readGRNLines(grn_id, bool) {
    this.spin.show();
    this.sharedService.getGRN_Lines(grn_id).subscribe((data: any) => {
      this.PO_GRN_Number_line = data.result[0];
      this.spin.hide();
      let grn_number;
      if (bool) {
        this.grnList.forEach(grn => {
          if (grn.idDocument == grn_id) {
            console.log(grn)
            grn_number = grn.GRNNumber;
            grn.isChecked = true;
          }
        });
        let data = [...this.PO_GRN_Number_line]
        this.selectedGRNList.push(grn_id);
        this.selectedGRNLines.push({ grnNumber: grn_number, linesData: data, grn_id: grn_id });
      } else {
        this.grnList.forEach(grn => {
          if (grn.idDocument == grn_id) {
            grn.isChecked = false;
          }
        })
        if (this.selectedGRNList.length > 0) {
          this.selectedGRNList = this.selectedGRNList.filter(grn => grn != grn_id);
          this.selectedGRNLines = this.selectedGRNLines.filter(grn => grn.grn_id != grn_id);
        }
      }
      let total_arr = []
      this.selectedGRNLines.forEach(el => {
        total_arr.push(el.linesData)
      })
      this.selected_GRN_total = total_arr.reduce((acc, arr) => {
        return acc + arr.reduce((subAcc, obj) => {
          if (obj.AmountExcTax) {
            return subAcc + parseFloat(obj.AmountExcTax);
          } else {
            return subAcc + (parseFloat(obj.UnitPrice) * parseFloat(obj.Quantity));
          }
        }, 0);
      }, 0);
    }, err => {
      this.error("Server error");
      this.spin.hide();
    })
  }

  ChangeGRNData() {
    if (this.selectedGRNList.length > 0) {
      this.dialogRef.close(this.selectedGRNList);
    } else {
      this.error("Please select at least one GRN");
      this.selected_GRN_total = 0;
    }
  }
  openDocumentView() {
    this.is_document_view = !this.is_document_view;
    if (!this.is_document_view) {
      this.is_grn_list_expanded = false;
      this.addExpandClass();
    } else {
      this.expand();
    }
  }
  openPdfLines() {
    this.is_inv_line_view = !this.is_inv_line_view;
  }
  closeDialogGrn() {
    this.dialogRef.close();
    this.grnList.forEach(grn => {
      grn.isChecked = false;
    })
  }
  expand() {
    this.is_grn_list_expanded = !this.is_grn_list_expanded;
    this.addExpandClass();
  }
  addExpandClass() {
    const leftDiv = document.querySelector('.left_div') as HTMLElement;
    const rightDiv = document.querySelector('.right_div') as HTMLElement;

    if (leftDiv && rightDiv) {
      if (this.is_grn_list_expanded) {
        leftDiv.style.width = '0';
        rightDiv.style.width = '100%';
      } else {
        leftDiv.style.width = '24%';
        rightDiv.style.width = '75%';
      }
    }
  }
}

